import React, {memo, useCallback, useMemo, useState} from 'react';

import './index.scss';
import {PasswordContainer} from '../../../../components/PasswordContainer';
import {useSelector} from 'react-redux';
import {SettingsPageContainer} from '../../../../components/Settings/SettingsPageContainer';
import {ColumnModel, SettingsList} from '../../../../components/Settings/SettingsList';
import {useSetSelector} from '../../../../hooks/set-selector';
import {useLocalization} from '../../../../hooks/localization';
import {ConciergeModel} from '../../../../types/concierge';
import {useRPC} from '../../../../hooks/rpc';

const keyExtractor = (item: ConciergeModel) => item.id;

export const ConciergeListScreen = memo(function ConciergeListScreen() {
    const {t} = useLocalization();
    const [rpc] = useRPC();
    const conciergeList = useSelector(state => state.control.conciergeList);
    const conciergeTypeList = useSetSelector(state => state.control.conciergeTypeList);

    const [selectedConcierge, setSelectedConcierge] = useState<ConciergeModel>(null);

    const buttons = useMemo(() => [
        {
            text: t('call_sip'),
            className: 'orange',
            hidden: !(selectedConcierge) || selectedConcierge.info.sip == null,
            onClick: () => {
                rpc.callIntercom(selectedConcierge.info.sip);
            },
        },
        {
            text: t('edit'),
            url: `/settings/concierge/edit/${selectedConcierge ? selectedConcierge.id : ''}`,
            className: 'orange',
            hidden: !(selectedConcierge),
        },
        {
            text: t('create_concierge'),
            url: '/settings/concierge/edit',
            className: 'green',
        },
    ], [rpc, t, selectedConcierge]);

    const displayNameExtractor = useCallback((item: ConciergeModel, column: ColumnModel) => {
        if (column.key === 'type_id') {
            return conciergeTypeList[item.type_id].name;
        }

        return item[column.key] || '-';
    }, [conciergeTypeList]);

    const columns = useMemo<ColumnModel[]>(() => [
        {
            length: 3,
            name: t('concierge_name'),
            key: 'name',
        },
        {
            length: 1,
            name: t('concierge_type'),
            key: 'type_id',
        },
    ], [t]);

    return (
        <PasswordContainer requiredRole="service" isFullscreen={true}>
            <SettingsPageContainer buttons={buttons} backUrl={'/settings'}>
                <SettingsList
                    columns={columns}
                    items={conciergeList}
                    displayNameExtractor={displayNameExtractor}
                    keyExtractor={keyExtractor}
                    selectedItem={selectedConcierge}
                    onItemSelected={setSelectedConcierge}/>
            </SettingsPageContainer>
        </PasswordContainer>
    );
});
